<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<!-- autosize to fix incorrect left margin on mat-sidenav-content (https://github.com/angular/material2/issues/6743) -->
<mat-sidenav-container class="tenant__sidenav-container" autosize="true">
  <mat-sidenav mode="side" opened [disableClose]="true">
    <div class="tenant">
      @if (isTenantDataLoading$ | async) {
      <mat-progress-spinner
        diameter="50"
        mode="indeterminate"
        color="accent"
      ></mat-progress-spinner>
      } @else { @if (tenantDetails$ | async; as tenantDetails) {
      <div class="tenant__header">
        <div>
          <span class="tenant__organisation">{{ tenantDetails.organizationId }}</span>
          <br />
          <span class="tenant__name">{{ tenantDetails.name }}</span>
        </div>
        @if (canLogin(userDetails$ | async, tenantDetails)) {
        <div class="login-button" (click)="loginToTenant(tenantDetails)">
          <i class="material-icons">forward</i>
        </div>
        }
      </div>
      } }
    </div>
    <mat-divider></mat-divider>
    @if (tenantDetails$ | async; as tenantDetails) {
    <og-menu-list
      [items]="menuItems"
      [disabled]="shouldDisableSidenavMenu(tenantDetails)"
      [disabledReason]="sidenavMenuDisabledReason(tenantDetails)"
    ></og-menu-list>
    <mat-divider></mat-divider>
    <div class="tenant-status__buttons">
      <button
        class="tenant-status__button"
        mat-button
        color="accent"
        (click)="onReadOnlyRoleSetupClick()"
      >
        <i class="material-icons">lock</i>
        Add read-only role
      </button>
      @if (tenantDetails.status; as tenantStatus) {
      <button
        class="tenant-status__button"
        mat-button
        color="accent"
        [disabled]="!canEnableTenant(tenantDetails)"
        (click)="onTenantStatusUpdate('enabled')"
      >
        <i class="material-icons">play_circle_outline</i>
        Enable Tenant
      </button>
      <button
        class="tenant-status__button"
        mat-button
        color="accent"
        [disabled]="!canDisableTenant(tenantDetails)"
        (click)="onTenantStatusUpdate('disabled')"
      >
        <i class="material-icons">block</i>
        Disable Tenant
      </button>
      }
    </div>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="og-content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (showDeleteConfirmationPanel) {
<div class="confirmation-dialog">
  @if (!deletionInProgress) {
  <og-confirmation-panel
    [text]="confirmationDialogText$ | async"
    (cancelClicked)="showDeleteConfirmationPanel = false"
    (confirmClicked)="onUserDeletion()"
  ></og-confirmation-panel>
  } @if (deletionInProgress) {
  <mat-progress-spinner [mode]="'indeterminate'" [color]="'primary'"></mat-progress-spinner>
  }
</div>
}
